import * as React from 'react';
import { t } from 'i18next';

import { BaseComponent } from './BaseComponent';
import { KompanStore } from '../Kompan/KompanStore';
import { ReadOnly } from '../constants/Enums';
import { KompanHelper } from '../Kompan';

interface CustomReadOnlyMessageState {
    show: boolean;
    readOnly: ReadOnly;
}

export class CustomReadOnlyMessage extends BaseComponent<{}, CustomReadOnlyMessageState> {
    public componentWillMount(): void {
        this.addStoreListener(KompanStore, this.onChange);
        this.onChange();
    }

    public render(): JSX.Element {
        let message: string = t('The file has been opened in read-only mode. Want to edit a copy?');
        if (this.state.readOnly === ReadOnly.Save) {
            message = t('A new variant has been saved. Want to edit a copy?');
        }
        return (
            <div className={'ui-core-done-message custom-ui-core-done-message' + (this.state.show ? ' show' : '')}>
                <div className="ui-core-done-message-box">
                    <div className="ui-core-done-message-label">{message} <button onClick={this.onClick}>Edit</button></div>
                </div>
            </div>
        );
    }

    protected onChange = (): void => {
        this.setState({
            show: KompanStore.getState().readOnly !== ReadOnly.Disabled,
            readOnly: KompanStore.getState().readOnly as ReadOnly
        });
    };

    protected onClick = (event: React.MouseEvent): void => {
        return void KompanHelper.disableReadOnly();
    };
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/CustomReadOnlyMessage.tsx